import { frontendURL } from '../../../helper/URLHelper';

import AssistantPageView from './AssistantPageView.vue';
import AnalyticsPage from './pages/AnalyticsPage.vue';
import KnowledgePage from './pages/KnowledgePage.vue';
import PlaygroundPage from './pages/PlaygroundPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import ToolsPage from './pages/ToolsPage.vue';

const meta = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/assistant'),
    component: AssistantPageView,
    redirect: { name: 'assistant_analytics_index' },
    children: [
      {
        path: 'analytics',
        name: 'assistant_analytics_index',
        component: AnalyticsPage,
        meta,
      },
      {
        path: 'knowledge',
        name: 'assistant_knowledge_index',
        component: KnowledgePage,
        meta,
      },
      {
        path: 'playground',
        name: 'assistant_playground_index',
        component: PlaygroundPage,
        meta,
      },
      {
        path: 'tools',
        name: 'assistant_tools_index',
        component: ToolsPage,
        meta,
      },
      {
        path: 'settings',
        name: 'assistant_settings_index',
        component: SettingsPage,
        meta,
      },
    ],
  },
];
